export enum DocumentStatus {
    None = 0,
    Suspended = 5,
    TransmitLater = 20,
    Open = 30,
    Transmitting = 40,
    Printed = 60,
    TransmittedNotConfirmed = 61,
    TransmittedByPhone = 65,
    TransmittedByInternet = 66,
    StockCharged = 90,
}